import * as Dtos from '../../dtos/Tmd.dtos';
import { IFieldState, IRegistrationFormState } from "./index";

export const initialTrialInstitutionFinanceState: Dtos.TrialInstitutionFinance & IRegistrationFormState = {
    id: null,
    trialInstitutionId: null,
    trialInstitution: null,
    overrideFundingEmail: null,
    fundingEmail: null,
    bsbSwift: null,
    accountNumber: null,
    siteCostCentre: null,
    requireInvoiceFromSite: null,
    overridePaymentDetails: null,
    abn: null,
    taxInvoiceName: null,
    quickbooksTaxCodeId: null,
    quickbooksTaxCode: null,
    active: null,
    dateEntered: null,
    dateModified: null,
    enteredBy: null,
    modifiedBy: null,
    saveAndReturn: false,
}

export interface ITrialInstitutionFinanceReduxFormState {
    id: IFieldState<number>,
    trialInstitutionId: IFieldState<number>,
    trialInstitution: IFieldState<Dtos.TrialInstitution>,
    quickbooksTaxCodeId: IFieldState<number>,
    overrideFundingEmail: IFieldState<boolean>,
    fundingEmail: IFieldState<string>,
    bsbSwift: IFieldState<string>,
    accountNumber: IFieldState<string>,
    siteCostCentre: IFieldState<string>,
    requireInvoiceFromSite: IFieldState<boolean>,
    overridePaymentDetails: IFieldState<boolean>,
    abn: IFieldState<string>,
    taxInvoiceName: IFieldState<string>,
    quickbooksTaxCode: IFieldState<Dtos.QuickbooksTaxCode>,
    active: IFieldState<boolean>,
    dateEntered: IFieldState<string>,
    dateModified: IFieldState<string>,
    enteredBy: IFieldState<string>,
    modifiedBy: IFieldState<string>
}
